import React from 'react'
// import { TransitionGroup, CSSTransition } from "react-transition-group";
// import FadeProps from 'fade-props'

import project from '../../project'

import { Tracking } from '../../../NodeModules/nnd-track-page'

// import { ajaxSetup } from 'jquery'
import HTMLFlipBook from 'react-pageflip';
import axios from 'axios';
// import { useRef } from 'react';

import "../assets/styles/home.scss"
import { event } from 'jquery';

const apiURL_storage = 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/interactives/MessageBoardParis2024/prod/MessageBoardParis2024.json'

// ajaxSetup({ cache: true })

let nndWMBtimer = ''

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      view: 'messages',
      firstInteraction: false,
      submitDisabled: false,
      submitSuccess: false,
      pauseMode: false,
      messageData: [],
      currentMessage: null,
      currentIndex: null,
      valueName: '',
      valueLocation: '',
      valueMessage: '',
      mode: null,
      isDesktop: null,
      bookMessages: undefined,
      heroImage: null,
      override: null,
      countName: 0,
      countLocation: 0,
      countMessage: 0,
      domain: window.location.hostname.replace('www.','').replace('.com.au','') //  codesports
    }
    
    this.handleChangeName = this.handleChangeName.bind(this);
    this.inputCount = this.inputCount.bind(this);
    this.handleChangeLocation = this.handleChangeLocation.bind(this);
    this.handleChangeMessage = this.handleChangeMessage.bind(this);
    this.nextBookButtonClick = this.nextBookButtonClick.bind(this);
    this.prevBookButtonClick = this.prevBookButtonClick.bind(this);
    const thisState = this

    // this.addBodyEvents()

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })

    const deviceAttribute = document.body.getAttribute('data-device')
    // console.log('isDeskMobAttribute', isDeskMobAttribute)
    const isDesktop = ( deviceAttribute === 'desktop' ) ? true : false
    thisState.state.isDesktop = isDesktop

    // console.log('isDesktop: ', isDesktop)

    const whichMode = appContainer.getAttribute('data-mode')
    // console.log('whichMode', whichMode)
    thisState.state.mode = whichMode
    
  }

  componentDidMount () {
    this.getHero()
    this.loadData ()
  }

  onSubmit (e) {
    // console.log('submission achieved', e)
    // console.log('THIS: ', this.state.valueMessage)

    this.setState({
      submitDisabled: true
    })

    if (this.state.valueName === '' || this.state.valueLocation === '' || this.state.valueMessage === '') {
      // console.log('the 3 fields are required')
      this.setState({
        submitDisabled: false
      })
      return
    }

    const data = {
      Message: this.state.valueMessage,
      Name: this.state.valueName,
      Location: this.state.valueLocation,
      Created: Date.now(),
      Approved: 'NO',
      Tribute: 'Olympics',
      Origin: window.location.href
    };

    // console.log('data', data)

    fetch('https://api.sheetmonkey.io/form/6j9ujgwLbTswqJByqDkApL', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    }).then((result) => {
      // Handle the result
      // console.log('result', result)
      this.setState({
        submitSuccess: true,
        submitDisabled: false
      })
      
    });

  }

  handleChangeName (event) {    
    // console.log('VVV')
    this.setState({valueName: event.target.value})
  }
  handleChangeLocation (event) {    
    this.setState({valueLocation: event.target.value})
  }
  handleChangeMessage (event) {    
    this.setState({valueMessage: event.target.value})
  }

  inputCount (event) {
    // console.log('Count This:',  event.target.name, event.target.value.length)
    // let whichCounter = null

    if (event.target.name == 'nam') {
      this.setState({
        countName: event.target.value.length
      })
    } else if (event.target.name == 'loc') {
      this.setState({
        countLocation: event.target.value.length
      })
    } else if (event.target.name == 'mes') {
      this.setState({
        countMessage: event.target.value.length
      })
    }
  }

  nextMessage (direction, mode) {
    // console.log('direction:', direction, ' mode: ', mode)
    // console.log('nndWMBtimer', nndWMBtimer)
    // user clicked
    if (mode === 'manual') {
      
      //clear timeout
      // console.log('CLEARED a settimeout', nndWMBtimer)
      clearTimeout(nndWMBtimer)

      this.setState({
        pauseMode: true
      })
      // console.log('Setting pause mode to true', this.state.pauseMode)

      // exit pause mode after 30 seconds, revert to auto 
      nndWMBtimer = setTimeout(() => {
        this.setState({
          pauseMode: false
        })
        // console.log('Setting pause mode to false', this.state.pauseMode)
      }, 30000)
      // console.log('SET a settimeout', nndWMBtimer)

    }

    const dataLength = this.state.messageData.length
    let newIndex = (direction === 'left') ? this.state.currentIndex - 1 : this.state.currentIndex + 1
    
    if ( newIndex > dataLength - 1 ) {
      newIndex = 0
    }
    if ( newIndex <  0 ) {
      newIndex = dataLength -1
    }

    const nextMessageObj = this.state.messageData[newIndex]
    // console.log('nextMessageObj', nextMessageObj)
    this.setState({
      currentMessage: nextMessageObj,
      currentIndex: newIndex
    })

  }

  startTimer () {
    // console.log('start Timer');
    setInterval(() => {
      // console.log('go right');
      // console.log('pauseMode: ', this.state.pauseMode);
      if (this.state.pauseMode === false) {
        this.nextMessage('right', 'auto')
      }
    }, 5000);
  }

  getHero () {
    
    const urlParams = new URLSearchParams(window.location.search);
    const override = urlParams.get('override');
    // console.log('override', override)
    
    
    // console.log( 'TIMESTAMP', Date.now() )
    // const currentTime = new Date().toLocaleString("en-US", { timeZone: "Australia/Sydney" });
    const currentTime = (override) ? override : Date.now();
    // console.log( 'currentTime', currentTime )

    let whichHero = null;

    if ( currentTime < 1722049200000 ) { // til 27/07/24 1pm
      whichHero = "Ariarne-Titmus"  //Elanor-Patterson
    } else if ( currentTime >= 1722049200000 && currentTime < 1722135600000 ) { // til 28/07/24 1pm
      whichHero = "Sam-Short" //Genevieve-Gregson
    } else if ( currentTime >= 1722135600000 && currentTime < 1722222000000 ) { // til 29/07/24 1pm
      whichHero = "Mollie-O-Callaghan"  //Jemima-Montag
    }  else if ( currentTime >= 1722222000000 && currentTime < 1722308400000 ) { // til 30/07/24 1pm
      whichHero = "Mary-Fowler" //Kelsey-Lee-Barber
    }  else if ( currentTime >= 1722308400000 && currentTime < 1722394800000 ) { // til 31/07/24 1pm
      whichHero = "Kaylee-McKeown" //Rohan-Browning
    }  else if ( currentTime >= 1722394800000 && currentTime < 1722481200000 ) { // til 1/08/24 1pm
      whichHero = "Zac-Stubblety-Cook" //Kyle-Chambers
    }  else if ( currentTime >= 1722481200000 && currentTime < 1722567600000 ) { // til 2/09/24 1pm
      whichHero = "Lizzie-Dekkers" 
    }  else if ( currentTime >= 1722567600000 && currentTime < 1722654000000 ) { // til 03/09/24 1pm
      whichHero = "Cam-McEvoy" 
    }  else if ( currentTime >= 1722654000000 && currentTime < 1722740400000 ) { // til 04/09/24 1pm
      whichHero = "Kurtis-Marschall" 
    }  else if ( currentTime >= 1722740400000 && currentTime < 1722826800000 ) { // til 05/09/24 1pm
      whichHero = "Torrie-Lewis" 
    }  else if ( currentTime >= 1722826800000 && currentTime < 1722913200000 ) { // til 06/09/24 1pm
      whichHero = "Nina-Kennedy" 
    }  else if ( currentTime >= 1722913200000 && currentTime < 1722999600000 ) { // til 07/09/24 1pm
      whichHero = "Calab-Law" 
    }  else if ( currentTime >= 1722999600000 && currentTime < 1723086000000 ) { // til 08/09/24 1pm
      whichHero = "Olli-Hoare" 
    }  else if ( currentTime >= 1723086000000 && currentTime < 1723172400000 ) { // til 09/09/24 1pm
      whichHero = "Nina-Kennedy" 
    }  else if ( currentTime >= 1723172400000 && currentTime < 1723258800000 ) { // til 10/09/24 1pm
      whichHero = "Michelle-Jenneke" 
    }  else if ( currentTime >= 1723258800000 && currentTime < 1723345200000 ) { // til 11/09/24 1pm
      whichHero = "Peter-Bol" 
    }  else if ( currentTime >= 1723345200000 && currentTime < 1723431600000 ) { // til 12/09/24 1pm
      whichHero = "Mackenzie-Little" 
    } else {
      whichHero = "Mary-Fowler" 
    }
      
    this.setState({
      heroImage: whichHero,
    })

  }

  loadData () {
    // lIVE
    axios.get(apiURL_storage)
    .then((response) => {
      // console.log('response', response)
      let titlesRemoved = response.data.values
      titlesRemoved.shift()
      this.processItems(titlesRemoved)
    })
    .catch((err) => {
      console.log('err', err)
    })

  }

  processItems (items) {
    // console.log('items', items)

    // show newest first
    items.reverse()

    if (this.state.mode === 'simple') {
      
      const randomIndex = Math.floor(Math.random()*items.length)
      const startItem = items[randomIndex]
      // console.log('startItem', randomIndex, startItem)

      this.setState({
        currentMessage: startItem,
        currentIndex: randomIndex,
        messageData: items
        // messageCount: items.length
      })

      this.startTimer()
    }

    if (this.state.mode === 'book') {
      // console.log('book mode: ', this.state.mode)
      // console.log('items', items);

      let groupedMessages = [];

      [...Array(Math.ceil(items.length / 5)).keys()].forEach(i => {
        // const [a, b, c, d, e] = items.slice(i * 5, (i+1) * 5)
        groupedMessages.push(items.slice(i * 5, (i+1) * 5))
     
        // a, b, c and d are the four elements of this iteration
        // console.log(`iteration n°${i}`, a, b, c, d, e)
      })

      // console.log('groupedMessages 1', groupedMessages)

      groupedMessages = ['start', ...groupedMessages, 'end']

      // console.log('groupedMessages 2', groupedMessages)


      this.setState({
        bookMessages: groupedMessages
      })
    }

  }

  nextBookButtonClick () {
    // console.log('this.flipBook', this.flipBook.pageFlip())
    this.flipBook.pageFlip().flipNext();
  }

  prevBookButtonClick () {
    this.flipBook.pageFlip().flipPrev();
  }

  render() {

    // const book = useRef();
    
    const message = (this.state.currentMessage !== null) ? this.state.currentMessage[0].trim() : 'Loading...'
    const name = (this.state.currentMessage !== null) ? this.state.currentMessage[1].trim() : ''
    const location = (this.state.currentMessage !== null) ? this.state.currentMessage[2].trim() : ''
    const messageIndex = (this.state.currentMessage !== null) ? this.state.currentIndex : ''
    // const messageCount = (this.state.messageCount !== null) ? this.state.messageCount : ''

    const totalMessage = <div key={messageIndex} className="nnd-message-wrap">
      {/*<span className="nnd-message-index">{ messageIndex + 1 } of { messageCount }</span>*/}
      <div className="nnd-message">{message}</div>
      <div className="nnd-from">{name}, {location}</div>
    </div>

    // console.log('this.state.bookMessages', this.state.bookMessages)

    const bookWidth = (this.state.isDesktop === true) ? 350 : 320;
    const bookHeight = (this.state.isDesktop === true) ? 705 : 600
    const bookSize = (this.state.isDesktop === true) ? 'stretch' : 'stretch'
    // console.log('bookWidth', bookWidth)
    // console.log('bookHeight', bookHeight)
    // console.log('bookSize', bookSize)
    const bookMinWidth = (this.state.isDesktop === true) ? 350 : 320;
    const bookMaxWidth = (this.state.isDesktop === true) ? 355 : 220;
    const bookMinHeight = (this.state.isDesktop === true) ? 705 : 600;
    const bookMaxHeight = (this.state.isDesktop === true) ? 705 : 600;
    
    const pages = (typeof this.state.bookMessages !== 'undefined') ? this.state.bookMessages.map((item, index) => {
      // console.log('FIRST')
      if (typeof this.state.bookMessages !== 'undefined') {
        // console.log('D: ', item, index)

        if (typeof item === 'string' && item === 'start') {
          return (
            <div key={index} className="nnd-page cover">
              
              <div className="nnd-heading">
                <span>Share your messages for The Australian Olympic Team</span>
              </div>
              {/*<div className="nnd-cover-footer">
                  {<a href="https://www.mytributes.com.au/" target="_blank">
                    <img alt="powered by mytributes" src={require(`../assets/images/mytributes.svg`)} className="nnd-cover-powered" />
                  </a>}
              </div>*/}
            </div>
          )
        }
        else if (typeof item === 'string' && item === 'end') {
          return (
            <div key={index} className="nnd-page cover end">
              <div className="nnd-heading">
                <span>The End</span>
              </div>
              {/*<div className="nnd-cover-footer">
                  {<a href="https://www.mytributes.com.au/" target="_blank">
                    <img alt="powered by mytributes" src={require(`../assets/images/mytributes.svg`)} className="nnd-cover-powered" />
                  </a>}
                </div>*/}
            </div>
          )
        }
        else {

          return (
            <div key={index} className={`nnd-page`} >
              <div className="nnd-page-header nnd-decor"></div>
              <div className="nnd-page-messages">
              {
                item.map((message, subIndex) => (
                  <div key={index + '-' + subIndex} className="nnd-message">
                    <div className="nnd-message-content">{message[0].trim()}</div>
                    <div className="nnd-message-name">- {message[1].trim()}, {message[2].trim()} -</div>
                  </div>
                ))
              }
              </div>
              <div className="nnd-page-footer nnd-decor">
                <div className="nnd-page-number">{index}</div>
              </div>
            </div>
          )
        }

      }
    }) : ''

    // console.log('pages', pages)

    return (
      <div className={`nnd-container ${this.state.domain ? 'nnd-' + this.state.domain : ""}`}>
        
        <div className="nnd-content-form">
          <div className="nnd-header">
            <h3>MESSAGE YOUR HEROES</h3>
          </div>
          {this.state.submitSuccess
            ? 
            <div className="nnd-form-thanks">
              <p>{this.state.valueName}</p>
              <p>Thanks for submitting your message for the Australian Olympic Team.</p>
            </div>
            :
            <div className="nnd-form">
              <label htmlFor="nnd-form-textarea" className="nnd-form-textarea-label">Enter your message below</label>
              <div className="inputRow">
                <input type="input" maxLength="20" disabled={false} className="nnd-form-input-name" name="nam" onChange={this.inputCount} onBlur={this.handleChangeName} placeholder="Name*" ></input>
                <span className="nnd-count-name nnd-count">
                  {/*<span className="nnd-countTop">{this.state.countName}</span>*/}
                  <span className="nnd-countBase">{20 - this.state.countName}</span>
                </span>
              </div>
              <div className="inputRow">
                <input type="input" maxLength="20" disabled={false} className="nnd-form-input-location" name="loc" onChange={this.inputCount} onBlur={this.handleChangeLocation} placeholder="Location*" ></input>
                <span className="nnd-count-location nnd-count">
                {/*<span className="nnd-countTop">{this.state.countLocation}</span>*/}
                  <span className="nnd-countBase">{20 - this.state.countLocation}</span>
                </span>
              </div>
              <div className="inputRow">
                <textarea type="textarea" maxLength="105" disabled={false} className="nnd-form-textarea" name="mes" onChange={this.inputCount} onBlur={this.handleChangeMessage} placeholder="Your message*" ></textarea>
                <span className="nnd-count-message nnd-count">
                {/*<span className="nnd-countTop">{this.state.countMessage}</span>*/}
                  <span className="nnd-countBase">{105 - this.state.countMessage}</span>
                </span>
              </div>
              <button type="button" disabled={this.state.submitDisabled} className="nnd-form-submitButton" onClick={(e) => { this.onSubmit(e) }}>Submit</button>
            </div>
          }
          <div className={`nnd-image-tribute ${this.state.heroImage ? 'nnd-' + this.state.heroImage : ""}`}></div>
        </div>
        
        {this.state.mode == 'book'
            ? 
            <div className="nnd-cont-main">
              <div className="nnd-book-messages">
                  <div className="nnd-nav-prev" onClick={this.prevBookButtonClick} title='PREVIOUS'></div>
                  <HTMLFlipBook 
                    width={bookWidth} 
                    height={bookHeight} 
                    size={bookSize}
                    minWidth={bookMinWidth}
                    maxWidth={bookMaxWidth}
                    minHeight={bookMinHeight}
                    maxHeight={bookMaxHeight}
                    className="nnd-book" 
                    autoSize={true}
                    maxShadowOpacity= {0.1}
                    showCover={true}
                    drawShadow={true}
                    ref={(el) => (this.flipBook = el)}>

                      { pages }
                    
                  </HTMLFlipBook>
                  <div className="nnd-nav-next" onClick={this.nextBookButtonClick} title='NEXT'></div>
              </div>
            </div>
            : 
            <div className="nnd-content-ticker">
              <div className="nnd-button-left" onClick={() => { this.nextMessage('left', 'manual') }}></div>
              {totalMessage}
              <div className="nnd-button-right" onClick={() => { this.nextMessage('right', 'manual') }}></div>
            </div>

        }
        
      </div>
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js